var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98.373,
    height: 98.369,
    viewBox: "0 0 98.373 98.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-copy-1186909",
    transform: "translate(-0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8989",
    "data-name": "Path 8989",
    d: "M212.559,137.473V70.918a1.2,1.2,0,0,0-1.273-1.273H140.913a1.2,1.2,0,0,0-1.273,1.273v6.108h-6.363V68.373a5.1,5.1,0,0,1,5.09-5.09h75.466a5.1,5.1,0,0,1,5.09,5.09v71.519a5.1,5.1,0,0,1-5.09,5.09H206.2v-6.363h5.09a1.169,1.169,0,0,0,1.273-1.144Z",
    transform: "translate(-120.548 -63.283)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M211.05,136.64h71.773a5.1,5.1,0,0,1,5.09,5.09v71.519a5.1,5.1,0,0,1-5.09,5.09H211.177a5.1,5.1,0,0,1-5.09-5.09V141.73a4.919,4.919,0,0,1,4.963-5.09Zm1.273,74.191A1.2,1.2,0,0,0,213.6,212.1h66.683a1.2,1.2,0,0,0,1.273-1.273V144.275A1.2,1.2,0,0,0,280.278,143H213.723a1.2,1.2,0,0,0-1.273,1.273V210.83Z",
    transform: "translate(-206.082 -119.97)",
    fill: "#5f5f5f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e85437779a37cf3bbc0f6104a59ebb82.svg";
export { ForwardRef as ReactComponent };